const config = {
  MMI_FiringEvent: 'MMI Events'
};

export default config;



//////////////////
// WEBPACK FOOTER
// ./config.js
// module id = null
// module chunks = 